// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"042bb37f","488":"7213179a","732":"0eb8fd42"}[chunkId] + ".chunk.js";
};